<div *ngIf="productDetail" class="product-detail-container">
  <div class="product-info">
    <!-- Product Title -->
    <h1>{{ productDetail.product.title }}</h1>

    <!-- Product Detail Section: Displaying 'detail' from filteredAttributes -->
    <div *ngFor="let attr of productDetail.filteredAttributes">
      <div [innerHTML]="attr.detail"></div>
    </div>

    <div class="attributes">
      <!-- Color Selection -->
      <label for="color">PARTIE:</label>
      <select id="color"
              [(ngModel)]="productDetail.selectedColorId"
              (ngModelChange)="onAttributeChange()">
        <option [ngValue]="null">Parties</option>
        <option *ngFor="let color of getAvailableColors()" [ngValue]="color.id">
          {{ color.title }}
        </option>
      </select>

      <!-- Size Selection -->
      <label for="size">Chapitre:</label>
      <select id="size"
              [(ngModel)]="productDetail.selectedSizeId"
              (ngModelChange)="onAttributeChange()"
              [disabled]="!getAvailableSizes().length">
        <option [ngValue]="null">Chapitres</option>
        <option *ngFor="let size of getAvailableSizes()" [ngValue]="size.id">
          {{ size.title }}
        </option>
      </select>

      <!-- Length Selection -->
      <label for="length">Cours:</label>
      <select id="length"
              [(ngModel)]="productDetail.selectedLengthId"
              (ngModelChange)="onAttributeChange()"
              [disabled]="!getAvailableLengths().length">
        <option [ngValue]="null">Cours</option>
        <option *ngFor="let length of getAvailableLengths()" [ngValue]="length.id">
          {{ length.title }}
        </option>
      </select>
    </div>

    <!-- Filtered Attributes Section -->
    <div class="filtered-attributes">
      <h3>Filtered Attributes:</h3>
      <ul>
        <li *ngFor="let attr of productDetail.filteredAttributes">
          <ng-container *ngIf="!attr.product.isFeatured && !attr.product.status; else priceAlert">
            <img *ngIf="attr.imageUrl" [src]="attr.imageUrl" alt="Image de {{ attr.product.title }}" />
            <button (click)="addToCart(attr, 1)">Add to Cart</button>
          </ng-container>

          <!-- Template for unavailable price -->
          <ng-template #priceAlert>
            <div>
              Price will be notified later.
              <img *ngIf="attr.imageUrl" [src]="attr.imageUrl" alt="Image de {{ attr.product.title }}" />
              <button (click)="addToCart(attr, 1)">Add to Cart</button>
            </div>
          </ng-template>

        </li>
      </ul>
    </div>

  </div>

  <!-- Product Image Section -->
  <div class="product-image">
    <img *ngIf="currentImageUrl" [src]="currentImageUrl" alt="Image actuelle du produit" />
  </div>

  <!-- Product Video Section -->
  <div class="product-video">
    <video *ngIf="currentVideoUrl" [src]="currentVideoUrl" controls autoplay loop muted>
      Votre navigateur ne prend pas en charge la lecture de vidéos.
    </video>
  </div>
</div>
